import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import './RsBreadcrumbTooltip.scss';

const overridePosition = (position, currentEvent, currentTarget, node, place) => {
  // weird bug in current version of library: sometimes parameters get misconfigured and
  // node is String "right" instead of HTMLElement
  if (typeof node.getBoundingClientRect !== 'function') {
    return position;
  }

  if (place === 'right') {
    const tootTipHeight = node.getBoundingClientRect().height;
    const deltaTop = tootTipHeight / 2;
    const top = Math.ceil(position.top + deltaTop);
    return { ...position, top };
  }

  return position;
};

function RsBreadcrumbTooltip({ id, children }) {
  return (
    <ReactTooltip
      id={id}
      place="right"
      effect="solid"
      delayHide={100}
      className="rs-tooltip-big"
      type="custom"
      clickable
      overridePosition={overridePosition}
      disableInternalStyle
      event="mouseenter"
      eventOff="mouseleave">
      {children}
    </ReactTooltip>
  );
}

RsBreadcrumbTooltip.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
};

export default RsBreadcrumbTooltip;
